import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getStudents, getQuestions, getTests } from '../../api';

function StatCard({ label, value, icon, color }) {
  return (
    <div className="card" style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
      <div style={{ width: 56, height: 56, borderRadius: 14, background: color,
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, flexShrink: 0 }}>
        {icon}
      </div>
      <div>
        <div style={{ fontSize: 28, fontWeight: 700, fontFamily: 'Sora', color: 'var(--text)' }}>{value ?? '—'}</div>
        <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>{label}</div>
      </div>
    </div>
  );
}

export default function AdminDashboard() {
  const students = useQuery({ queryKey: ['students'], queryFn: () => getStudents().then(r => r.data) });
  const tests = useQuery({ queryKey: ['allTests'], queryFn: () => getTests().then(r => r.data) });

  return (
    <div>
      <h1 style={{ fontSize: 26, marginBottom: 8 }}>Dashboard</h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: 32 }}>Overview of the NEET prep platform</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 20, marginBottom: 40 }}>
        <StatCard label="Students" value={students.data?.length} icon="👥" color="#EEF2FF" />
        <StatCard label="Tests Given" value={tests.data?.length} icon="📝" color="#F0FDF4" />
        <StatCard label="Completed Tests" value={tests.data?.filter(t => t.status === 'completed').length} icon="✅" color="#FFF7ED" />
      </div>

      <div className="card">
        <h2 style={{ fontSize: 18, marginBottom: 20 }}>Recent Tests</h2>
        {tests.isLoading ? <div className="spinner"></div> : (
          <table className="table">
            <thead><tr>
              <th>Student</th><th>Title</th><th>Questions</th><th>Status</th><th>Date</th>
            </tr></thead>
            <tbody>
              {tests.data?.slice(0, 10).map(t => (
                <tr key={t.id}>
                  <td style={{ fontWeight: 500 }}>{t.student_id?.slice(0,8)}…</td>
                  <td>{t.title || 'Untitled'}</td>
                  <td>{t.total_questions}</td>
                  <td><span className={`badge ${t.status === 'completed' ? 'badge-green' : 'badge-yellow'}`}>{t.status}</span></td>
                  <td style={{ color: 'var(--text-muted)', fontSize: 13 }}>{new Date(t.started_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
